// extracted by mini-css-extract-plugin
export var phone = "_1u-0";
export var phoneDragging = "_1u-1";